import { useState, useEffect } from "react";

export interface AdminUser {
  id: string;
  email: string;
  name: string | null;
}

export type AuthState =
  | { status: "loading" }
  | { status: "authenticated"; user: AdminUser }
  | { status: "unauthenticated" }
  | { status: "forbidden" };

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;

    async function checkAuth() {
      try {
        const baseURL = import.meta.env.VITE_API_URL || "/api";
        const res = await fetch(`${baseURL}/admin/me`, {
          credentials: "include",
        });

        if (cancelled) return;

        if (res.ok) {
          const user = await res.json();
          setState({ status: "authenticated", user });
        } else if (res.status === 401) {
          setState({ status: "unauthenticated" });
        } else if (res.status === 403) {
          setState({ status: "forbidden" });
        } else {
          setState({ status: "unauthenticated" });
        }
      } catch {
        if (!cancelled) {
          setState({ status: "unauthenticated" });
        }
      }
    }

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
